/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'feedback-collector.anonymous': '이 피드백은 익명으로 제출됩니다. Atlassian은 이 피드백과 관련하여 귀하에게 직접 연락할 수 없습니다',
  'feedback-collector.anonymous.title': '익명 피드백',
  'feedback-collector.can-be-contacted.label': '예, Atlassian 팀에서 Atlassian 제품 및 서비스 개선을 위해 연락하여 제 경험에 대해 물어봐도 괜찮습니다. 본인은 <a>Atlassian 개인정보 보호정책</a>을 인정합니다.',
  'feedback-collector.cancel-button.label': '취소',
  'feedback-collector.default.custom.textarea.label': '피드백을 공유해 주세요.',
  'feedback-collector.enrol-in-research.label': '제품 조사에 참여하고 싶습니다',
  'feedback-collector.feedback-title': '피드백 공유',
  'feedback-collector.form.bug.label': '버그 또는 이슈 설명',
  'feedback-collector.form.comment.label': '의견을 알려주세요',
  'feedback-collector.form.empty.label': '옵션 선택',
  'feedback-collector.form.question.label': '무엇을 알고 싶습니까?',
  'feedback-collector.form.suggestion.label': '개선하기 원하는 내용을 알려주세요',
  'feedback-collector.option.bug.label': '버그 보고',
  'feedback-collector.option.comment.label': '댓글 남기기',
  'feedback-collector.option.default.label': '의견 선택',
  'feedback-collector.option.default.placeholder': '하나 선택',
  'feedback-collector.option.question.label': '질문하기',
  'feedback-collector.option.suggestion.label': '개선 사항 제안',
  'feedback-collector.required.fields.summary': '필수 필드는 별표로 표시되어 있습니다',
  'feedback-collector.submit-button.label': '피드백 보내기',
  'feedback-collector.success-flag.description': '소중한 피드백은 Atlassian의 제품을 개선하는 데 도움이 됩니다.',
  'feedback-collector.success-flag.title': '감사합니다!',
  'feedback-collector.summary-placeholder': '의견을 알려주세요',
  'proforma-form-builder.feedback-icon-label': '피드백',
  'proforma-form-builder.give-feedback': '피드백 보내기'
};